module.exports = __webpack_public_path__ + "static/Lamentum2-45fa2d4ca47e7135b368659baa321657.png";